/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./leaders.vue?vue&type=template&id=55497cbd"
import script from "./leaders.vue?vue&type=script&lang=js"
export * from "./leaders.vue?vue&type=script&lang=js"
import style0 from "./leaders.vue?vue&type=style&index=0&id=55497cbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports